(function($){
  $.fn.richTextEditor = function(options){
    const settings = $.extend({
      height: 220,
      minWord: 1500,
      maxWord: 2000,
      placeholder: "请输入内容..." // 默认占位符
    }, options);

    return this.each(function(){
      const $textarea = $(this);
      // 销毁旧编辑器，防止重复生成
      const $prevEditor = $textarea.next('.rich-editor-wrap');
      if($prevEditor.length > 0){
        $prevEditor.remove();
      }
      $textarea.hide();

      let isOverTipShow = false;

      const editorHtml = `
      <div class="rich-editor-wrap">
        <div class="rich-content" contenteditable="true" style="min-height:${settings.height}px;border:1px solid #ccc;padding:8px;"></div>
        <div class="rich-count">0 / ${settings.minWord}-${settings.maxWord}</div>
      </div>
      `;
      const $editorWrap = $(editorHtml);
      $textarea.after($editorWrap);
      const $editArea = $editorWrap.find('.rich-content');
      const $countTip = $editorWrap.find('.rich-count');

      // 设置初始值
      let initVal = $textarea.val();
      $editArea.html(initVal);

      // 判断是否为空（去除html标签和空白）
      function isEmptyContent(html){
        const txt = html.replace(/<[^>]+>/g,'').replace(/\s/g,'');
        return txt.length === 0;
      }

      // 显示/隐藏placeholder
      function togglePlaceholder(){
        const html = $editArea.html();
        if(isEmptyContent(html)){
          $editArea.addClass('rich-placeholder');
          $editArea.attr('data-placeholder', settings.placeholder);
        }else{
          $editArea.removeClass('rich-placeholder');
          $editArea.removeAttr('data-placeholder');
        }
      }

      // 获取纯文本字数（过滤HTML标签、空白字符）
      function getPureWordNum(str){
        return str.replace(/<[^>]+>/g,'').replace(/\s/g,'').length;
      }

      // 更新字数统计UI
      function updateWordCount(){
        let html = $editArea.html();
        let num = getPureWordNum(html);
        $countTip.text(`当前字数：${num} / 要求 ${settings.minWord}-${settings.maxWord}`);

        if(num < settings.minWord){
          $countTip.removeClass('error').addClass('warn');
        }else if(num > settings.maxWord){
          $countTip.removeClass('warn').addClass('error');
        }else{
          $countTip.removeClass('warn error');
          isOverTipShow = false;
        }
      }

      // 焦点事件处理placeholder
      $editArea.on('focus',function(){
        if(isEmptyContent($editArea.html())){
          $editArea.removeClass('rich-placeholder');
        }
      });
      $editArea.on('blur',function(){
        togglePlaceholder();
      });

      // 输入监听
      $editArea.on('input keyup paste blur', function(){
        togglePlaceholder();
        let pureText = $editArea.text().replace(/\s/g,'');
        if(pureText.length > settings.maxWord){
          if(!isOverTipShow){
            alert(`字数上限为${settings.maxWord}字，已自动截断内容！`);
            isOverTipShow = true;
          }
          // 只截取纯文本长度，这里简单处理，会丢失html标签；如需保留html安全裁剪告诉我
          let limitPure = $editArea.text().replace(/\s/g,'').substring(0, settings.maxWord);
          $editArea.text(limitPure);
        }
        $textarea.val($editArea.html());
        updateWordCount();
      });

      // 初始化
      togglePlaceholder();
      updateWordCount();

      $textarea.data('richEditor', $editArea);
      $textarea.data('checkWordLength', function(){
        let num = getPureWordNum($editArea.html());
        if(num < settings.minWord){
          return {pass:false,msg:`字数不足，最少需要${settings.minWord}字`};
        }
        if(num > settings.maxWord){
          return {pass:false,msg:`字数超标，最多${settings.maxWord}字`};
        }
        return {pass:true,msg:'字数合规'};
      });
    });
  }
})(jQuery);

// 页面加载初始化
$(function(){
  $('#p_video_desc').richTextEditor({
    height: 240,
    minWord: 50,
    maxWord: 5000,
    placeholder:"一、创作说明\n简要阐述作品创作背景、选题立意、核心主题与表达主旨；注明实拍素材、引用素材、公有版权素材来源。\n 二、AI工作流说明\n 写明所使用AI工具名称、各环节技术应用点，区分人工创作与AI生成部分；可附关键提示词、流程截图作为佐证。\n 三、落地应用构想（注：本部分为可选内容。具备传播、商用、场景转化的作品需填写。）"
  });
  $('#shu_zp_desc').richTextEditor({
    height: 240,
    minWord: 50,
    maxWord: 5000,
    placeholder:"填写作品创作说明，阐述创作思路、津派文化元素融入方式及改编转化构想"
  });
});